import React from 'react';

import { Switch, Route, Redirect } from 'react-router-dom';

import { ErrorScreen } from '../screens/error-screen';
import { QuizScreen } from './quiz-screen/quiz-screen-mobile';
import { ReinstallApp } from '../screens/error-screen/reinstall-app';

export const MainMobileScreen: React.FunctionComponent = () => (
	<Switch>
		<Route path="/error/reinstall-app">
			<ReinstallApp />
		</Route>
		<Route path="/error">
			<ErrorScreen />
		</Route>
		<Route path="/test">
			<QuizScreen />
		</Route>
		<Redirect to="/error" />
	</Switch>
);
